import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Helpers from '@rogues/shared/mixins/helpers';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name InfoBox
 */
export default class InfoBox extends Mixins(Helpers, HybridMixin, Props) {
    /**
     * Return the Tag type
     * 
     * @returns {string}
     */
    get tagType(): string {
        if (this.getValue('link')) {
            return typeof this.getValue('link') === 'object' ? 'router-link' : 'a';
        }

        return this.getValue('tag', this.tag);
    }

    /**
     * Attribute to bind to the rogue
     * 
     * @returns {object}
     */
    get attr(): object {
        const link: {[k: string]: string | object} = {};
        if (this.getValue('link')) {
            const type = typeof this.getValue('link');
            if (type === 'string') {
                link.href = this.getValue('link');
            } else {
                let params: {[k: string]: string | object} = {};
                if (this.getValue('url_encode')) {
                    params = { url_encode: this.getValue('url_encode') };
                } else {
                    params = { id: this.getValue('id') };
                }
                link.to = { ...this.getValue('link'), params };
            }
        }
        return link;
    }
}
